export default __webpack_public_path__ + "b5a2e1b69d03546fa28db7d17f8a8cb3.png";